import { render } from "./message-templates.vue?vue&type=template&id=5c364fc4&scoped=true"
import script from "./message-templates.vue?vue&type=script&lang=js"
export * from "./message-templates.vue?vue&type=script&lang=js"

import "./message-templates.vue?vue&type=style&index=0&id=5c364fc4&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c364fc4"]])

export default __exports__